import { render, staticRenderFns } from "./Notificação.vue?vue&type=template&id=53335884&scoped=true"
import script from "./Notificação.vue?vue&type=script&lang=js"
export * from "./Notificação.vue?vue&type=script&lang=js"
import style0 from "./Notificação.vue?vue&type=style&index=0&id=53335884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53335884",
  null
  
)

export default component.exports